module.exports = "/hwa/_next/static/images/skip-5fd411b40654eddce48fc02e27556b73.png";